// component/GoogleMapPicker.tsx
import React from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

interface Props {
  latitude: number;
  longitude: number;
  onSelectLocation: (lat: number, lng: number) => void;
}

const containerStyle = {
  width: "100%",
  height: "400px"
};

const GoogleMapPicker: React.FC<Props> = ({ latitude, longitude, onSelectLocation }) => {
  const center = { lat: latitude || 39.925533, lng: longitude || 32.866287 }; // default: Ankara

  const handleClick = (e: google.maps.MapMouseEvent) => {
    if (e.latLng) {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      onSelectLocation(lat, lng);
    }
  };

  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={10}
        onClick={handleClick}
      >
        <Marker position={{ lat: latitude, lng: longitude }} />
      </GoogleMap>
    </LoadScript>
  );
};

export default GoogleMapPicker;
